import React, { useState, useEffect } from "react";
import "./TopFive.scss";
import "./TopFiveMobile.scss";
import triple from "../../Assets/manga-tripple-quote.png";
import seemoreArrow from "../../Assets/Seemore-arrow.png";
import seemoreInverted from "../../Assets/Seemore-inverted.png";
import AnimeFigureCard from "../Utilities/AnimeFigureCard";
import { useNavigate } from "react-router-dom";
import ProductText from "./ProductText";
import MainContentModal from "../../PageProducts/ProductContent/PPCMainContent/MainContentModal/MainContentModal";
import ViewProductModal from "../../PageProducts/ProductContent/PPCMainContent/MainContentModal/ViewProductModal/ViewProductModal";
import { useAppContext } from "../../Components/AppProvider";
import { useMediaQuery } from "react-responsive";
export default function TopFive({ data, titleName, state, filter, id }) {
  const [seemoreHover, setSeemoreHover] = useState(false);
  const imagePath = "Assets/AnimeFigures";
  const [isModalOpen, setModalOpen] = useState(false);
  const [productId, setProductId] = useState(null);
  const [isAdding, setIsAdding] = useState(false);
  const [likedMap, setLikedMap] = useState({});
  const { customerId } = useAppContext();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 600 });
  // ✅ Toggle wishlist add/remove
  const toggleLike = async (productId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/customer-profile`,
        {
          credentials: "include",
        }
      );
      const data = await res.json();

      if (!data?.CP_ID) {
        const confirmLogin = window.confirm(
          "You need to log in to manage your wishlist. Log in now?"
        );
        if (confirmLogin) navigate("/login");
        return;
      }

      const customerId = data.CP_ID;
      const isLiked = likedMap[productId];
      const command = isLiked ? "remove" : "add";

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/wishlist/add-drop-wish/${productId}/${customerId}/${command}`,
        {
          method: "POST",
          credentials: "include",
        }
      );

      if (response.ok) {
        setLikedMap((prev) => ({ ...prev, [productId]: !isLiked }));
      } else {
        console.error("Wishlist toggle failed");
      }
    } catch (error) {
      console.error("Error toggling wishlist:", error);
    }
  };

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        if (!customerId) return;

        const wishRes = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/wishlist/get-wishlist-by-id/${customerId}`
        );
        const wishData = await wishRes.json();

        //console.log("wishData:", wishData);

        if (wishRes.ok && Array.isArray(wishData)) {
          const map = {};
          wishData.forEach((p) => (map[p.PD_ID] = true));
          setLikedMap(map);
        }
      } catch (err) {
        console.error("Failed to fetch wishlist:", err);
      }
    };
    fetchWishlist();
  }, []);
  return (
    <>
      <div className="topFive-container" id={id}>
        <div className="title">
          <div className="title-container">
            <div className="title-wrapper-black">
              <div className="title-wrapper-white-dashed">
                <p>{titleName}</p>
              </div>{" "}
              <img className="tripleQoute" src={triple}></img>
              <img className="tripleQoute2" src={triple}></img>
            </div>
          </div>
        </div>
        <div className="topfive-content">
          <div className="topFive-card-container">
            {data.length ? (
              data.map((product) => (
                <div className="topFive-card-wrapper" key={product.PD_ID}>
                  <div className="prod-picture-wrapper">
                    {/* Product Image */}
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${product.PD_ID}/${product.PD_ProductPicPath?.[0]}`}
                      alt={product.PD_Name}
                      onClick={() => {
                        if (!isMobile) {
                          setProductId(product.PD_ID);
                          setModalOpen(true);
                        }
                      }}
                    />
                  </div>
                  <div className="prod-card-details">
                    <ProductText text={product.PD_Name} />
                    {product.PD_ProductType === "onhand" ? (
                      <>
                        {product.PD_SalePrice === 0 ? (
                          // show only the original price if there’s no sale
                          <span className="sale-price">{`PHP ${product.PD_OriginalPrice}`}</span>
                        ) : (
                          // show both original (strikethrough) and sale price
                          <>
                            <span className="original-price">{`PHP ${product.PD_OriginalPrice}`}</span>
                            <span className="sale-price">{` PHP ${product.PD_SalePrice}`}</span>
                          </>
                        )}
                      </>
                    ) : (
                      // for non-"onhand" products
                      <span className="sale-price">{`PHP ${product.PD_OriginalPrice}`}</span>
                    )}
                  </div>

                  <button
                    className="view-product-btn"
                    onClick={() => {
                      navigate(`/products/${product.PD_ID}`, {
                        state: { isLiked: likedMap[product.PD_ID] },
                      });
                    }}
                  >
                    View Product Details
                  </button>
                </div>
              ))
            ) : (
              <div className="no-products">Your topFive is empty.</div>
            )}
          </div>

          <button
            className="btn-seemore"
            onClick={() => {
              localStorage.setItem(
                "redirectAfterLogin",
                JSON.stringify({
                  path: window.location.pathname,
                  scrollTop: 0,
                })
              );
              navigate("/products", {
                state: { sortVal: state, filterVal: filter },
              });
            }}
          >
            S E E M O R E
          </button>
          <div
            className="na-seemore"
            onMouseEnter={() => setSeemoreHover(true)}
            onMouseLeave={() => setSeemoreHover(false)}
            onClick={() => {
              localStorage.setItem(
                "redirectAfterLogin",
                JSON.stringify({
                  path: window.location.pathname,
                  scrollTop: 0,
                })
              );
              navigate("/products", {
                state: { sortVal: state, filterVal: filter },
              });
            }}
          >
            <p>
              &nbsp;S
              <br />
              &nbsp;E
              <br />
              &nbsp;E
              <br />
              <br />
              &nbsp;M
              <br />
              &nbsp;O
              <br />
              &nbsp;R
              <br />
              &nbsp;E
            </p>

            {/* Stacked images for circular reveal */}
            <img
              className="seemore-img seemore-img-base"
              src={seemoreArrow}
              alt="See more arrow"
              draggable="false"
              style={{ pointerEvents: "none" }}
            />
            <img
              className="seemore-img seemore-img-inverted"
              src={seemoreInverted}
              alt="See more arrow inverted"
              draggable="false"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>
      </div>
      <MainContentModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      >
        <ViewProductModal productId={productId} onToggleLike={toggleLike} />
      </MainContentModal>
    </>
  );
}
